<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card invoice p-0">
          <!-- Card header -->
          <div
            class="d-lg-flex justify-content-between align-items-center mx-2 pb-0 card-header invoice"
          >
            <h5>Users</h5>
            <div class="d-flex gap-3">
              <div class="flex-grow-1">
                <input
                  type="text"
                  v-model="searchQuery"
                  class="form-control invoice"
                  placeholder="Search..."
                />
              </div>
              <div class="">
                <button
                  @click="openAddForm"
                  class="bg-success btn text-white rounded py-0"
                  :style="{ height: '35px' }"
                >
                  Add New
                </button>
              </div>
            </div>
          </div>
          <div class="px-0 pb-0 card-body">
            <!-- Table -->
            <div class="table-responsive" v-if="filteredUsers.length > 0">
              <div class="card mb-4">
                <div class="card-body px-0 pt-0 pb-2 invoice">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-sm">Name</th>
                          <th class="text-sm">Email</th>
                          <th class="text-sm">Contact</th>
                          <th class="text-sm">Role</th>
                          <th class="text-sm">Status</th>
                          <th class="text-sm">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in filteredUsers" :key="index">
                          <td class="text-sm">{{ item?.user?.username }}</td>
                          <td class="text-sm">{{ item?.user?.email }}</td>
                          <td class="text-sm">{{ item.number }}</td>
                          <td class="text-sm">{{ item.user_role }}</td>
                          <td class="text-sm">
                            <span
                              :class="
                                item.status
                                  ? 'active-status'
                                  : 'inactive-status'
                              "
                            >
                              {{ item.status ? "Active" : "Inactive" }}
                            </span>
                          </td>
                          <td>
                            <div
                              class="d-flex align-items-center"
                              style="gap: 12px"
                            >
                            <template v-if="hasPermission('2023')">
                              <i
                                class="fas fa-edit cursor-pointer"
                                title="Edit"
                                @click="openEditForm(item)"
                              ></i>
                              <i
                                class="fas fa-trash text-danger cursor-pointer"
                                title="Delete"
                                @click="deleteItem(item.id)"
                              ></i>
                            </template>
                              <i
                                v-if="item.status == false"
                                class="fas fa-play cursor-pointer text-success"
                                title="Active"
                                @click="holdItem(item.id, true)"
                              ></i>
                              <i
                                v-if="item.status == true"
                                class="fas fa-pause cursor-pointer text-success"
                                title="Hold"
                                @click="holdItem(item.id, false)"
                              ></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <Skalaton />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Sliding Panel -->
    <div class="form-panel" :class="{ 'is-open': isFormPanelOpen }">
      <div class="form-header">
        <h5 v-if="isEditing">Edit User</h5>
        <h5 v-else>Add New User</h5>
        <span @click="toggleFormPanel" class="item">
          <Close />
        </span>
      </div>
      <form
        @submit.prevent="saveUser"
        class="d-flex flex-column"
        style="gap: 10px"
      >
        <div>
          <label class="form-label">Username</label>
          <input
            type="text"
            placeholder="Username"
            class="form-control invoice-card"
            v-model="form.user.username"
            required
          />
        </div>
        <div>
          <label class="form-label">Email</label>
          <input
            type="email"
            placeholder="Email"
            class="form-control invoice-card"
            v-model="form.user.email"
            required
          />
        </div>
        <div>
          <label class="form-label">Password</label>
          <input
            type="password"
            placeholder="Password"
            class="form-control invoice-card"
            v-model="form.user.password"
          />
        </div>
        <div>
          <label class="form-label">Contact Number</label>
          <input
            type="text"
            placeholder="Contact Number"
            class="form-control invoice-card"
            v-model="form.number"
          />
        </div>
        <div>
          <label class="form-label">Address</label>
          <input
            type="text"
            placeholder="Address"
            class="form-control invoice-card"
            v-model="form.address"
          />
        </div>
        <div>
          <label class="form-label">Branch</label>
          <select class="form-control bg" v-model="form.zones" multiple>
            <option
              v-for="(data, index) in branches"
              :key="index"
              :value="data.id"
            >
              {{ data.name }}
            </option>
          </select>
        </div>

        <div>
          <label class="form-label">ISP Name</label>
          <input
            type="text"
            placeholder="ISP Name"
            class="form-control invoice-card"
            v-model="form.isp_name"
          />
        </div>
        <div>
          <label class="form-label">Role</label>
          <select class="form-control bg" v-model="form.user_role">
            <option value="" selected disabled>Select Role</option>
            <option
              v-for="(data, index) in roles"
              :key="index"
              :value="data.id"
            >
              {{ data.name }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label">Send Message</label>
          <input type="checkbox" class="mx-1 mt-1" v-model="form.send_msg" />
        </div>
        <div class="mt-4">
          <button type="submit" class="btn btn-success">
            {{ isEditing ? "Update" : "Save" }}
          </button>
        </div>
      </form>
    </div>

    <div class="col-6 text-end" v-if="delete_popup">
      <div class="popup_bg"></div>
      <div id="myModal" class="modal_class">
        <div class="modal-content invoice p-4 shadow-lg rounded">
          <div class="d-flex justify-content-center align-items-center mb-3">
            <h5 class="text-center m-0">Are you sure?</h5>
          </div>
          <div class="text-center">
            <button @click="deleteUser" class="btn btn-danger w-40 mx-1">
              Yes, delete it!
            </button>
            <button @click="popup_close" class="btn btn-success w-40 mx-1">
              No, keep it
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 text-end" v-if="hold_popup">
      <div class="popup_bg"></div>
      <div id="myModal" class="modal_class">
        <div class="modal-content invoice p-4 shadow-lg rounded">
          <div class="d-flex justify-content-center align-items-center mb-3">
            <h5 class="text-center m-0">Are you sure?</h5>
          </div>
          <div class="text-center">
            <button @click="holdUser" class="btn btn-danger w-40 mx-1">
              Yes, hold it!
            </button>
            <button @click="popup_close" class="btn btn-success w-40 mx-1">
              No, keep it
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";
import Close from "../components/Icon/Close.vue";
import { useUserApi } from "../services/user.service";
import showSwal from "@/mixins/showSwal.js";
import { hasPermission } from "@/utils/permissions.js";

export default {
  name: "UserList",
  components: { Skalaton, Close },
  data() {
    return {
      users: [],
      roles: [],
      branches: [],
      searchQuery: "",
      isFormPanelOpen: false,
      isEditing: false,
      delete_popup: false,
      hold_popup: false,
      selected_status: false,
      selected_id: "",
      editingId: null,
      form: {
        user: {
          username: "",
          email: "",
          password: "",
        },
        number: "",
        address: "",
        isp_name: "",
        send_msg: false,
        user_role: "",
        zones: [],
      },
    };
  },
  async mounted() {
    this.getData();
    this.getRole();
    this.getBranch();
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery) {
        return this.users;
      }
      const query = this.searchQuery.toLowerCase();
      console.log("Search Query:", query);
      return this.users.filter((user) => {
        const matches = (obj) => {
          for (let key in obj) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
              if (matches(obj[key])) return true;
            } else if (
              typeof obj[key] === "string" &&
              obj[key].toLowerCase().includes(query)
            ) {
              return true;
            }
          }
          return false;
        };
        return matches(user);
      });
    },
  },

  methods: {
    hasPermission,
    async getData() {
      try {
        const response = await useUserApi().getUserData();
        this.users = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async popup_close() {
      this.selected_id = "";
      this.delete_popup = false;
      this.hold_popup = false;
    },
    async deleteItem(id) {
      if (!hasPermission("2024")) {
        showSwal.methods.showSwal({
                type: "error",
                  message: "You do not have permission to perform this action.",
                });
        return;
      }

      this.selected_id = id;
      this.delete_popup = true;
    },
    async holdItem(id, status) {
      this.selected_id = id;
      this.selected_status = status;
      this.hold_popup = true;
    },
    async getRole() {
      try {
        const response = await useUserApi().getRole();
        this.roles = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async getBranch() {
      try {
        const response = await useUserApi().getBranchesData();
        this.branches = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    toggleFormPanel() {
      this.isFormPanelOpen = !this.isFormPanelOpen;
    },
    openAddForm() {
      this.isEditing = false;
      this.resetForm();
      this.toggleFormPanel();
    },
    openEditForm(user) {
      if (!hasPermission("2024")) {
        showSwal.methods.showSwal({
                type: "error",
                  message: "You do not have permission to perform this action.",
                });
        return;
      }

      this.isEditing = true;
      this.editingId = user.id;
      this.form = JSON.parse(JSON.stringify(user)); // Clone user data into form
      this.toggleFormPanel();
    },
    async saveUser() {
      try {
        if (this.isEditing) {
          // Update existing user
          await useUserApi().putUserData(this.form, this.editingId);
          this.getData();
          showSwal.methods.showSwal({
            type: "success",
            message: "User Updated successfully!",
          });
        } else {
          // Add new user
          const response = await useUserApi().postUserData(this.form);
          this.users.push(response);
          showSwal.methods.showSwal({
            type: "success",
            message: "User added successfully!",
          });
        }
        this.resetForm();
        this.toggleFormPanel();
      } catch (error) {
        console.error("Error saving user:", error);
        showSwal.methods.showSwal({
          type: "success",
          message: "Failed to process request!",
        });
      }
    },
    resetForm() {
      this.form = {
        user: {
          username: "",
          email: "",
          password: "",
        },
        number: "",
        address: "",
        isp_name: "",
        send_msg: false,
        user_role: "User",
        zones: [],
      };
    },
    async deleteUser() {
      // if (confirm("Are you sure you want to delete this user?")) {
      try {
        await useUserApi().deleteUserData(this.selected_id);
        this.getData();
        showSwal.methods.showSwal({
          type: "success",
          message: "User deleted successfully!",
        });
        this.popup_close();
      } catch (error) {
        // console.error("Error deleting user:", error);
        showSwal.methods.showSwal({
          type: "success",
          message: "Failed deleted successfully!",
        });
      }

      // }
    },
    async holdUser() {
      // if (confirm("Are you sure you want to delete this user?")) {
      try {
        await useUserApi().holdUserData(this.selected_id, this.selected_status);
        this.getData();
        showSwal.methods.showSwal({
          type: "success",
          message: "User hold successfully!",
        });
        this.popup_close();
      } catch (error) {
        // console.error("Error deleting user:", error);
        showSwal.methods.showSwal({
          type: "success",
          message: "Failed hold successfully!",
        });
      }

      // }
    },
  },
};
</script>

<style>
td {
  padding: 12px 24px !important;
}

.active-status {
  background: green !important;
  color: white !important;
  padding: 0 5px;
  border-radius: 5px;
}
.dark-mode .active-status {
  color: white !important;
}
.dark-mode .inactive-status {
  color: white !important;
}
.inactive-status {
  background: red !important;
  color: white !important;
  padding: 0 5px;
  border-radius: 5px;
}

/* ===============panel---------- */
.form-panel {
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  width: 400px;
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1050;
}
.dark-mode .form-panel {
  background-color: #061f3e !important;
}
.form-panel.is-open {
  right: 0;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dark-mode .bg {
  background-color: #061f3e !important;
  color: white;
}
</style>
